import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const SplashScreen = () => {
  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setStartAnimation(true);
    }, 120);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center overflow-hidden bg-gradient-to-br from-green-50 via-white to-lime-50">
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={i}
            initial={{
              opacity: 0,
              x: 100 + i * 180,
              y: -120,
              rotate: i * 35,
            }}
            animate={{
              opacity: [0, 0.12, 0],
              y: ["0vh", "110vh"],
              rotate: i * 35 + 180,
            }}
            transition={{
              duration: 3.5 + i * 0.25,
              delay: i * 0.25,
              repeat: Infinity,
              ease: "linear",
            }}
            className="absolute text-4xl md:text-5xl"
          >
            🌿
          </motion.div>
        ))}
      </div>

      <div className="relative z-10 px-6 text-center">
        <div className="relative mb-10 flex justify-center">
          <motion.div
            initial={{ scale: 0.2, opacity: 0 }}
            animate={
              startAnimation
                ? {
                    scale: [0.2, 1.08, 1],
                    opacity: [0, 1, 1],
                  }
                : {}
            }
            transition={{
              duration: 1.15,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="relative"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.6 }}
              animate={
                startAnimation
                  ? {
                      opacity: [0, 0.35, 0.22],
                      scale: [0.7, 1.15, 1],
                    }
                  : {}
              }
              transition={{
                duration: 1.2,
                ease: "easeOut",
              }}
              className="absolute inset-0 rounded-full bg-green-400/30 blur-3xl"
            />

            <motion.img
              src="/img/splash-logo.png"
              alt="Samaniega's Landscaping"
              initial={{ scale: 0.15, rotate: -220, opacity: 0 }}
              animate={
                startAnimation
                  ? {
                      scale: [0.15, 1.12, 1],
                      rotate: [-220, 12, 0],
                      opacity: [0, 1, 1],
                    }
                  : {}
              }
              transition={{
                duration: 1.25,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="relative z-10 mx-auto h-auto w-36 drop-shadow-2xl sm:w-40 md:w-48"
            />
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={startAnimation ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.7, duration: 0.7 }}
          className="mb-10"
        >
          <h2 className="text-3xl font-extrabold tracking-wide text-black sm:text-4xl md:text-5xl">
            SAMANIEGA&apos;S
          </h2>
          <h3 className="mt-1 text-xl font-medium text-green-700 sm:text-2xl md:text-3xl">
            Landscaping LLC
          </h3>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={startAnimation ? { opacity: 1 } : {}}
          transition={{ delay: 0.95 }}
          className="flex h-16 items-end justify-center gap-3"
        >
          {[0, 1, 2, 3, 4].map((index) => (
            <motion.div
              key={index}
              animate={{
                scaleY: [0.25, 1, 0.7, 1, 0.45, 1],
                scaleX: [0.7, 1, 0.85, 1, 0.8, 1],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: index * 0.15,
                ease: "easeInOut",
              }}
              className="origin-bottom rounded-t-full"
              style={{
                width: "8px",
                height: `${22 + index * 8}px`,
                background:
                  "linear-gradient(to top, #166534, #84cc16, #d9f99d)",
              }}
            />
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={startAnimation ? { opacity: 1 } : {}}
          transition={{ delay: 1 }}
          className="mx-auto mt-8 h-2 w-44 overflow-hidden rounded-full bg-green-100 sm:w-52"
        >
          <motion.div
            initial={{ width: 0 }}
            animate={startAnimation ? { width: "100%" } : {}}
            transition={{
              duration: 3.1,
              ease: "easeInOut",
            }}
            className="h-full rounded-full bg-gradient-to-r from-green-700 via-lime-500 to-green-600"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default SplashScreen;
